import { useEffect, useRef } from "react";
import { createChart } from "lightweight-charts";

export function LineChart({ points, testId, height = 240, color = "#38BDF8" }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current || !points?.length) { return; }
    const chart = createChart(ref.current, { height, autoSize: true,
      layout: { background: { type: "solid", color: "#121824" }, textColor: "#94A3B8" },
      grid: { vertLines: { color: "#1E293B" }, horzLines: { color: "#1E293B" } }, timeScale: { timeVisible: true } });
    const s = chart.addLineSeries({ color, lineWidth: 2 });
    const seen = new Map();
    for (const p of points) { seen.set(Math.floor(new Date(p.t).getTime() / 1000), Number(p.v)); }
    s.setData([...seen.entries()].sort((a, b) => a[0] - b[0]).map(([time, value]) => ({ time, value })));
    chart.timeScale().fitContent();
    return () => { chart.remove(); };
  }, [points, height, color]);
  if (!points?.length) return <div data-testid={`${testId}-empty`} className="text-xs text-slate-500 p-4">No history yet.</div>;
  return <div ref={ref} data-testid={testId} className="w-full" />;
}
